(ns app.front.view.admin.migration.fix-brantford-property-ids
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/fix-brantford-property-integration-ids
    :title     "Fix Brantford properties' invalid integration ids"
    :help-text (str "Brantford properties that had their integration ids set to OBJECTID between 2025-07-16 and "
                    "2025-08-07 will be updated to have PropertyRSN as the integration-id.")}
   match])

(def route
  {:name        :view/admin.migration.fix-brantford-ids
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/fix-brantford-property-integration-ids]))}]})
